import React from "react";
import styles from "./KeyboardKey.module.scss";
import { text } from "../../utils/i18n";

type Props = {
  value: string;
  style?: React.CSSProperties;
}

/**
 * Renders an image of a keyboard key.
 */
export const KeyboardKey: React.FC<Props> = ({ value: key, style }) => {
  key = key?.toUpperCase() || text`ingen`;

  return (
    <div className={styles.container} style={style}>
      {
        //  - ser ut som "ingen tangent".
        key === "-" ? "MINUS" :
          key === " " ? "SPACE" :
            key
      }
    </div>
  );
}